export interface OrderItem {
  id: string;
  name: string;
  quantity: string;
}

export interface CurrentStop {
  number: number;
  name: string;
  message: string;
  // Backend stop id passed through so action buttons can hit the API
  stopId?: number;
}

export interface FailureReason {
  id: string;
  label: string;
}

export const failureReasons: FailureReason[] = [
  { id: 'store-closed', label: 'Store Closed' },
  { id: 'customer-unavailable', label: 'Customer Unavailable' },
  { id: 'partial-delivery', label: 'Partial Delivery Only' },
  { id: 'payment-refused', label: 'Payment Refused' },
  { id: 'damaged-goods', label: 'Damaged Goods' },
  { id: 'address-issue', label: 'Address Issue' },
  { id: 'unable-to-access', label: 'Unable to Access' },
  { id: 'short-shipment', label: 'Short Shipment' },
  { id: 'wrong-product', label: 'Wrong Product' },
  { id: 'reschedule-requested', label: 'Reschedule Requested' },
];
